import { FC, ReactNode } from 'react';

import { version } from '../../../../../package.json';

interface IRoomFooterTextProps {
  children?: ReactNode;
}

export const RoomFooterText: FC<IRoomFooterTextProps> = ({ children }) => (
  <p className="text-center text-sm leading-[1.1] text-[#322E66] sm:text-base sm:leading-4">
    {children || <>DApp v: {version}</>}
  </p>
);
